'use client';

import type { ClassValue } from 'clsx';
import type { ProductToCompareT } from '../../../../../../type/product/productComparison';

import {
  ProductComparisonItemCell,
  ProductComparisonLabelCell,
  ProductComparisonLabelCellVariant,
  ProductComparisonRow,
  ProductComparisonRowList,
  ProductComparisonRowVariant,
} from '@vs-shop/commerce-ui/productComparison';

import { clsxm } from '@vs-shop/utils';

import { productComparisonDrag, productComparisonDrop } from '../../dragState';

import ProductComparisonAddProductToCartButton from '../ProductComparisonAddProductToCartButton';

type Props = {
  products: readonly ProductToCompareT[];
  draggingIndex: number | null;
  dragOverIndex: number | null;
  className?: ClassValue;
};

export default function ProductComparisonHeaderAddToCartRow({
  products,
  draggingIndex,
  dragOverIndex,
  className,
}: Props) {
  return (
    <ProductComparisonRow variant={ProductComparisonRowVariant.PLAIN} className={clsxm(className)}>
      {/* LEFT INFO */}
      <ProductComparisonLabelCell variant={ProductComparisonLabelCellVariant.HEADER} />

      {/* PRODUCT COLUMNS */}
      <ProductComparisonRowList>
        {products.map((product, index) => (
          <ProductComparisonItemCell
            key={product.code}
            drag={productComparisonDrag(draggingIndex, index)}
            drop={productComparisonDrop(dragOverIndex, index)}
          >
            <ProductComparisonAddProductToCartButton product={product} />
          </ProductComparisonItemCell>
        ))}
      </ProductComparisonRowList>
    </ProductComparisonRow>
  );
}
